import Footer from 'components/Footer';
import React, { useEffect, useRef } from 'react';

const CONTACT_ITEMS = [
  {
    icon: 'images/con_map.png',
    title: 'Address',
    label: '오시는 길',
    text: '서울특별시 강남구 테헤란로113길 7 백제아트센타 별관내 4층',
  },
  {
    icon: 'images/con_phone.png',
    title: 'TEL',
    label: '대표전화',
    text: '02-556-1764',
    href: 'tel:025561764',
  },
  {
    icon: 'images/con_fax.png',
    title: 'FAX',
    label: '팩스',
    text: '02-556-1735',
    href: 'tel:025561735',
  },
  {
    icon: 'images/con_mail.png',
    title: 'E-Mail',
    label: '이메일',
    text: 'biz@eksys.co.kr',
    href: 'mailto:biz@eksys.co.kr',
  },
];

function Contact() {
  const refs = useRef([]);

  useEffect(() => {
    const targets = refs.current.filter(Boolean);

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      targets.forEach((target) => target.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.22,
      }
    );

    targets.forEach((target) => observer.observe(target));

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <section className="contact_head contact">
        <div className="contact_hero_inner contact_reveal" ref={(el) => (refs.current[0] = el)}>
          {/* <span className="contact_eyebrow">eKsys Contact</span> */}
          <h2>CONTACT</h2>
          <p>
            고객의 업무환경에 맞는 최적의 IT 솔루션을 위해<br />
            이케이시스가 함께 고민하겠습니다.
          </p>
        </div>
      </section>

      <section className="contact_section">
        <div className="contact_section_head contact_reveal" ref={(el) => (refs.current[1] = el)}>
          <strong className="contact_core_title">Company Information</strong>
          <span>
            찾아오시는 길과 문의 정보를 확인하실 수 있습니다.
          </span>
        </div>

        <div className="contact_content">
          <div className="contact_map_area contact_reveal" ref={(el) => (refs.current[2] = el)}>
            <div className="contact_map_frame">
              <iframe
                title="이케이시스 위치 지도"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6329.777835278039!2d127.06591300000001!3d37.510538!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca441440e621b%3A0x68a2c4526f68dd59!2z7ISc7Jq47Yq567OE7IucIOqwleuCqOq1rCDthYztl6TrnoDroZwxMTPquLggNw!5e0!3m2!1sko!2skr!4v1712304712472!5m2!1sko!2skr"
                width="100%"
                height="650"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="contact_info_panel contact_reveal" ref={(el) => (refs.current[3] = el)}>
            <div className="contact_info_top">
              <span>INFORMATION</span>
              <h3>이케이시스</h3>
              <p>
                방문 및 사업 문의가 필요하신 경우 아래 연락처로 문의해주세요.
              </p>
            </div>

            <div className="contact_info_list">
              {CONTACT_ITEMS.map((item) => (
                <div className="contact_info_card" key={item.title}>
                  <div className="contact_info_icon">
                    <img src={item.icon} alt="" aria-hidden="true" />
                  </div>

                  <div className="contact_info_text">
                    <strong>{item.title}</strong>
                    <span>{item.label}</span>

                    {item.href ? (
                      <a href={item.href}>{item.text}</a>
                    ) : (
                      <p>{item.text}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="contact_action_wrap">
              <a
                href="https://www.google.com/maps/search/?api=1&query=서울특별시 강남구 테헤란로113길 7"
                target="_blank"
                rel="noreferrer"
                className="contact_action primary"
              >
                지도 크게 보기
              </a>

              <a href="mailto:biz@eksys.co.kr" className="contact_action">
                이메일 문의
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;

